import React from 'react';
import LinkStatusIndicatorIcon from './LinkStatusIndicatorIcon';

const LastRefreshIconPicker = ({ linkStatus, ...rest }) => {
  switch (linkStatus) {
    case 'good':
      return (
        <LinkStatusIndicatorIcon
          fill={'secondary'}
          {...rest}
        />
      );
    default:
      return null;
  }
};

export default LastRefreshIconPicker;
